import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44df6431")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")

  return (_openBlock(), _createBlock(_component_a_form_item, {
    label: "选择线路",
    name: _ctx.name,
    rules: { required: _ctx.required, message: '请选择外呼线路' },
    style: { marginBottom: _ctx.size != 'small' ? '24px' : '0' }
  }, {
    default: _withId(() => [
      _createVNode(_component_a_select, {
        options: _ctx.options,
        value: _ctx.selectValue,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectValue = $event)),
        onChange: _ctx.changeSelect,
        style: {"width":"300px"},
        size: _ctx.size
      }, null, 8, ["options", "value", "onChange", "size"])
    ]),
    _: 1
  }, 8, ["name", "rules", "style"]))
})